import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  COURSE_CREATED_LIST_GET,
  COURSE_ACTIVITIES_GET,
  COURSE_STATS_GET,
  COURSE_USERS_GET,
  COURSE_USERS_ACTIVITIES_GET,
  GROUP_COURSES_GET,
  STATS_GROUP_LIST_GET,
  MY_COURSES_GET,
  MY_USERS_GET,
  SAVE_PRINT_SETTINGS,
  STATS_USER_LIST,
  USER_COURSES_GET,
  USER_GROUPS_GET,
  USER_STATS_GET,
  SURVEY_STATS_GET,
  SURVEY_FREE_TEXT_ANSWERS_GET,
  PRINT_SETTINGS_RESET,
  MULTI_PRINT_MY_COURSES,
  MULTI_PRINT_MY_CHARTS_CSV,
  MULTI_PRINT_MY_USERS,
  PRINT_MY_TUTORS,
  PRINT_MY_CATEGORIES,
  MULTI_PRINT_MY_ACTIVITIES,
  EVENT_SESSIONS_GET,
  COURSE_USERS_ACTIVITIES_RESET,
  EVENT_USERS_GET,
  EVENT_USERS_ACTIVITIES_GET,
  PRINT_ACCESS_CSV,
  PRINT_MY_TUTORS_CSV,
  PRINT_CATEGORIES_CSV,
  PRINT_COURSES_CSV,
  PRINT_ACTIVITIES_CSV,
  STATS_USERS_RESET,
  COURSE_CREATED_LIST_RESET,
} from '../actions/statistics';
import { COURSE_STATISTICS_LIST_GET } from '../actions/supervisorStats';

const initialState = {
  users: {
    list: [],
    filters: {},
    pager: {},
  },
  tutors: {
    list: [],
    activities: [],
    filters: {},
    pager: {},
  },
  user: {},
  courses: {
    list: [],
    activities: [],
    filters: {},
    pager: {},
  },
  groups: {
    list: [],
    pager: {},
  },
  course: {
    createdCourses: {
      list: [],
      filters: {},
      pager: {},
      courses: {
        list: [],
        filters: {},
        pager: {},
      },
      events: {
        list: [],
        filters: {},
        pager: {},
      },
    },
    activities: {
      list: [],
    },
    users: {
      list: [],
      activities: [],
      filters: {},
      pager: {},
    },
    survey: {},
  },
  groupCourses: {
    list: [],
    pager: {},
  },
  charts: {
    myCourses: {},
    myUsers: {
      filters: {},
      assignments: [],
      fruitions: [],
      completions: [],
      cache_tag: '',
    },
  },
  printSettings: {
    charts: {
      format: 'csv',
      users: { status: 'ko' },
      access: { status: 'ko' },
      tutors: { status: 'ok' },
      categories: { status: 'ko' },
      courses: { status: 'ko' },
      activities: { status: 'ko' },
    },
    courses: {
      activities: true,
      users: true,
      survey: true,
      selectedCourses: [],
    },
    users: {},
  },
  printStatus: {},
  printCharts: {
    users: {},
    courses: {},
  },
};

const statisticsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case STATS_USER_LIST._SUCCESS: {
        const { response, pager, saveIn, filters } = action;
        if (saveIn !== 'users') {
          if (!filters?.filters_only) {
            draft.tutors.list = response?.items || [];
            draft.tutors.pager = pager || {};
          }
          draft.tutors.filters = response?.filters || {};
        }
        if (saveIn !== 'tutors') {
          if (!filters?.filters_only) {
            draft.users.list = response?.items || [];
            draft.users.pager = pager || {};
          }
          draft.users.filters = response?.filters || {};
        }
        break;
      }

      case USER_STATS_GET._SUCCESS: {
        draft.user = action?.response || {};
        break;
      }

      case USER_COURSES_GET._SUCCESS: {
        const { response, pager } = action;
        draft.courses.list = response?.items || [];
        draft.courses.filters = response?.filters || {};
        draft.courses.pager = pager || {};
        break;
      }

      case USER_GROUPS_GET._SUCCESS: {
        const { response } = action;
        draft.groups.list = response?.items || [];
        draft.groups.pager = response?.pager || {};
        break;
      }

      case COURSE_STATS_GET._SUCCESS: {
        draft.course = { ...state.course, ...action.response };
        break;
      }

      case COURSE_CREATED_LIST_GET._SUCCESS: {
        const { response, pager, filters, isSupervisor } = action;
        if (isSupervisor && filters?.typology === 'course') {
          draft.course.createdCourses.courses.list = response?.items || [];
          draft.course.createdCourses.courses.filters = response?.filters || {};
          draft.course.createdCourses.courses.pager = pager || {};
        } else if (isSupervisor && filters?.typology === 'event') {
          draft.course.createdCourses.events.list = response?.items || [];
          draft.course.createdCourses.events.filters = response?.filters || {};
          draft.course.createdCourses.events.pager = pager || {};
        } else {
          draft.course.createdCourses.list = response?.items || [];
          draft.course.createdCourses.filters = response?.filters || {};
          draft.course.createdCourses.pager = pager || {};
        }
        break;
      }
      case COURSE_CREATED_LIST_RESET: {
        draft.course.createdCourses = initialState.course.createdCourses;
        break;
      }

      case COURSE_ACTIVITIES_GET._SUCCESS: {
        const { response } = action;
        draft.course.activities.list = response?.sections || [];
        break;
      }

      case EVENT_SESSIONS_GET._SUCCESS: {
        const { response } = action;
        draft.course.activities = response || {};
        break;
      }

      case COURSE_USERS_GET._SUCCESS: {
        const { response, pager, filters } = action;
        if (!filters?.filters_only) {
          draft.course.users.list = response?.items || [];
          draft.course.users.pager = pager || {};
        }
        draft.course.users.filters = response?.filters || {};
        break;
      }

      case EVENT_USERS_GET._SUCCESS: {
        const { response, pager, filters } = action || {};
        if (!filters?.filters_only) {
          draft.course.users.list = response?.items || [];
          draft.course.users.pager = pager || {};
        }
        draft.course.users.filters = response?.filters || {};
        break;
      }

      case STATS_USERS_RESET: {
        draft.course.users = initialState.course.users;
        break;
      }

      case SURVEY_STATS_GET._SUCCESS: {
        draft.course.survey = action?.response || {};
        break;
      }

      case SURVEY_FREE_TEXT_ANSWERS_GET._SUCCESS: {
        const { questionId, answers, pager } = action;
        draft.course.survey[questionId] = { answers: answers?.items, pager };
        break;
      }

      case COURSE_USERS_ACTIVITIES_RESET: {
        draft.course.users.activities = initialState.course.users.activities;
        draft.courses.activities = initialState.courses.activities;
        break;
      }
      case COURSE_USERS_ACTIVITIES_GET._SUCCESS: {
        draft.course.users.activities = action?.response || [];
        draft.courses.activities = action?.response || [];
        break;
      }

      case EVENT_USERS_ACTIVITIES_GET._SUCCESS: {
        const { response } = action;
        const data = response?.items || [];
        if (data?.length > 0) {
          const sessions = data[0]?.course_stats?.sessions;
          draft.course.users.activities = sessions || [];
          draft.courses.activities = sessions || [];
        }
        break;
      }

      case STATS_GROUP_LIST_GET._SUCCESS: {
        const { items, pager } = action?.response || {};
        draft.groups.list = items || [];
        draft.groups.pager = pager || {};
        break;
      }

      case GROUP_COURSES_GET._SUCCESS: {
        draft.groupCourses.list = action?.response?.items || [];
        draft.groupCourses.pager = action?.response?.pager || {};
        break;
      }

      case MY_COURSES_GET._SUCCESS: {
        draft.charts.myCourses = {
          year: action.year,
          ...(action?.response || {}),
        };
        break;
      }

      case MY_USERS_GET._SUCCESS: {
        draft.charts.myUsers = {
          filters: action.response?.assignments?.filters || {},
          assignments: action.response?.assignments?.items || {},
          fruitions: action.response?.fruitions?.items || {},
          completions: action.response?.completions?.items || {},
          cache_tag: action.response?.assignments?.cache_tag || '',
        };
        if (action?.filters?.filter) {
          draft.printCharts.users[action.filters.filter] = {
            assignments: action.response?.assignments?.items || [],
            fruitions: action.response?.fruitions?.items || [],
            completions: action.response?.completions?.items || [],
          };
        }
        break;
      }

      case COURSE_STATISTICS_LIST_GET._SUCCESS: {
        if (action?.filters?.filter) {
          draft.printCharts.courses[action.filters.filter] =
            action.response?.courses_by_filter;
        }
        break;
      }

      case SAVE_PRINT_SETTINGS: {
        const { chartType = '', key, value, tab } = action;
        if (chartType) {
          draft.printSettings[tab][chartType] = {
            ...state.printSettings[tab][chartType],
            [key]: value,
          };
        } else {
          draft.printSettings[tab] = {
            ...state.printSettings[tab],
            [key]: value,
          };
        }
        break;
      }

      case MULTI_PRINT_MY_CHARTS_CSV._REQUEST:
      case PRINT_ACCESS_CSV._REQUEST:
      case PRINT_MY_TUTORS_CSV._REQUEST:
      case PRINT_CATEGORIES_CSV._REQUEST:
      case PRINT_COURSES_CSV._REQUEST:
      case PRINT_ACTIVITIES_CSV._REQUEST:
      case MULTI_PRINT_MY_COURSES._REQUEST:
      case MULTI_PRINT_MY_USERS._REQUEST:
      case PRINT_MY_TUTORS._REQUEST:
      case PRINT_MY_CATEGORIES._REQUEST:
      case MULTI_PRINT_MY_ACTIVITIES._REQUEST: {
        const { key } = action;
        draft.printStatus[key] = 'loading';
        break;
      }
      case MULTI_PRINT_MY_CHARTS_CSV._SUCCESS:
      case PRINT_ACCESS_CSV._SUCCESS:
      case PRINT_MY_TUTORS_CSV._SUCCESS:
      case PRINT_CATEGORIES_CSV._SUCCESS:
      case PRINT_COURSES_CSV._SUCCESS:
      case PRINT_ACTIVITIES_CSV._SUCCESS:
      case MULTI_PRINT_MY_COURSES._SUCCESS:
      case MULTI_PRINT_MY_USERS._SUCCESS:
      case PRINT_MY_TUTORS._SUCCESS:
      case PRINT_MY_CATEGORIES._SUCCESS:
      case MULTI_PRINT_MY_ACTIVITIES._SUCCESS: {
        const { key } = action;
        draft.printStatus[key] = 'ok';
        break;
      }
      case MULTI_PRINT_MY_CHARTS_CSV._ERROR:
      case PRINT_ACCESS_CSV._ERROR:
      case PRINT_MY_TUTORS_CSV._ERROR:
      case PRINT_CATEGORIES_CSV._ERROR:
      case PRINT_COURSES_CSV._ERROR:
      case PRINT_ACTIVITIES_CSV._ERROR:
      case MULTI_PRINT_MY_COURSES._ERROR:
      case MULTI_PRINT_MY_USERS._ERROR:
      case PRINT_MY_TUTORS._ERROR:
      case PRINT_MY_CATEGORIES._ERROR:
      case MULTI_PRINT_MY_ACTIVITIES._ERROR: {
        const { key } = action;
        draft.printStatus[key] = 'ko';
        break;
      }

      case PRINT_SETTINGS_RESET: {
        draft.printSettings = initialState.printSettings;
        draft.printStatus = initialState.printStatus;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default statisticsReducer;
